import { render, staticRenderFns } from "./PanelErrorElem.vue?vue&type=template&id=19ed00c9&"
import script from "./PanelErrorElem.vue?vue&type=script&lang=js&"
export * from "./PanelErrorElem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports